export enum BillingType {
	POSTPAID = 'POSTPAID',
	PREPAID = 'PREPAID',
	DEFAULT = '',
}

export enum AccountType {
	MOBILE = 'MOBILE',
	FIX = 'FIX',
	INTERNET = 'INTERNET',
	DEFAULT = '',
	WFBB = 'WFBB',
	AAMALI = 'AAMALI',
}

export type SingleAccount = {
	_isMain: string;
	isMain: boolean;
	accountId: string;
	bAccountId: string;
	createdAt: string;
	activatedAt: string;
	accountNum: string;
	description: string;
	upAccountId: string;
	billingType: BillingType;
	accountType: AccountType;
	accountPlan: string;
	adslLogin: string;
	isPrepaid: boolean;
	isPostpaid: boolean;
	id: number;
	login: string;
	userId: string;
	userType: string; //E.g: 'ADMIN' | 'MANAGER' | 'ENDUSER' | '';
	deptId: string;
	accountCategory?: string;
};

const model: types.models.InputModel = {
	_isMain: 'IS_MAIN',
	id: 'id',
	accountId: 'accountId',
	bAccountId: 'bAccountId',
	createdAt: 'CREATED_AT',
	activatedAt: 'ACTIVATED_AT',
	accountNum: 'accountNum',
	description: 'DESCRIPTION',
	upAccountId: 'upAccountId',
	billingType: 'billingType',
	accountType: 'accountType',
	userId: 'userId',
	accountPlan: 'ACCOUNT_PLAN.xsi_ns-sep_nil',
	adslLogin: 'ADSL_LOGIN.xsi_ns-sep_nil',
	login: 'username',
	userType: 'userType',
	deptId: 'deptId',
	accountCategory: 'accountCategory',
	isPrepaid: function(model: SingleAccount) {
		return model.billingType === BillingType.PREPAID;
	},
	isPostpaid: function(model: SingleAccount) {
		return model.billingType === BillingType.POSTPAID;
	},
	isMain: function(model: SingleAccount) {
		return !!Number(model._isMain);
	},
};

export default model;
